//#region src/default_selection_type.ts
let DefaultSelectionType = /* @__PURE__ */ function(DefaultSelectionType) {
	DefaultSelectionType["None"] = "none";
	DefaultSelectionType["BiteOrPos"] = "bite-or-pos";
	DefaultSelectionType["Bite"] = "bite";
	DefaultSelectionType["Pos"] = "pos";
	return DefaultSelectionType;
}({});
//#endregion
export { DefaultSelectionType };

//# sourceMappingURL=default_selection_type.js.map